import { State } from '../../application/Store'

export const getCompany = (state: State) => {
    return state.company.company
}
